import MuiFormControlLabel, { FormControlLabelProps as MuiFormControlLabelProps } from '@mui/material/FormControlLabel';
import * as React from 'react';

export interface FormControlLabelProps extends MuiFormControlLabelProps {}

export const FormControlLabel = (props: FormControlLabelProps) => {
  return <MuiFormControlLabel {...props} />;
};
